"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var Enquire_1 = require("@/pages/common/components/Enquire");
var Login_1 = require("@/pages/common/components/Login");
var Message_1 = require("@/pages/common/components/Message");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var MortgageCommonAction_1 = require("@/pages/mortagage/actions/MortgageCommonAction");
var classNames = require("classnames");
var React = require("react");
var react_redux_1 = require("react-redux");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var mapStateToProps = function (state, ownProps) {
    var articles = [];
    if (ownProps.articlesTitles && ownProps.articlesTitles.length) {
        articles.push({
            name: state.translate.learnMore,
            children: ownProps.articlesTitles.map(function (it, i) { return ({
                name: it,
                link: "#article-" + i
            }); })
        });
    }
    var newState = __assign(__assign({}, ownProps), { menu: __assign(__assign({}, state.mortgageSidebar), { children: __spreadArrays(state.mortgageSidebar.children, articles) }) });
    return newState;
};
var mapDispatchToProps = function (dispatch) { return ({
    onMortgageMenuClicked: function () { return dispatch(MortgageCommonAction_1.default.onMortgageMenuClicked()); }
}); };
var mortgagePage = function (props) {
    var renderMenuItem = function (it, i, props) {
        var classes = classNames([
            'c-accordian', {
                'c-accordian--selected': it.page === props.currentPage,
            },
        ]);
        var renderChildren = function (it, props) {
            if (!it.children || it.children.length === 0)
                return;
            var renderChildrenItem = function (it, i, props) {
                var childClassname = classNames([
                    'c-accordian__item', {
                        'c-accordian__item--active': it.page === props.currentPage,
                    },
                ]);
                return (React.createElement("a", { key: i, href: it.link, className: childClassname }, it.name));
            };
            return (React.createElement("div", { className: "c-accordian__body" }, it.children.map(function (it, i) { return renderChildrenItem(it, i, props); })));
        };
        return (React.createElement("div", { key: i, className: classes },
            React.createElement("a", { href: it.link, className: "c-accordian__head" },
                React.createElement("span", { className: "c-accordian__icon c-accordian__dot" }),
                React.createElement("span", { className: "c-accordian__text" }, it.name)),
            renderChildren(it, props)));
    };
    var title = props.menu.children.find(function (it) { return it.page === props.currentPage; }).name;
    var bodyClass = classNames(['l-accordian__body', {
            'l-accordian__body--active': props.menuActive,
        }]);
    return (React.createElement("div", { id: "mortgagepage" },
        React.createElement(Bigpopup_1.default, null),
        React.createElement(Message_1.default, null),
        React.createElement(MegaMenu_1.default, { nobottom: true }),
        React.createElement("div", { className: "c-bighead", style: { backgroundImage: "url(/res/img/skyline_hk.jpg)", backgroundPosition: 'top left', backgroundSize: '100%' } },
            React.createElement("h1", { className: "c-bighead__title" }, title)),
        React.createElement("div", { className: "l-container l-container--r48  l-container--stackable l-container--alignleft-sm" },
            React.createElement("div", { className: "l-container__side" },
                React.createElement("div", { className: "l-accordian" },
                    React.createElement("div", { className: "l-accordian__head", onClick: props.onMortgageMenuClicked },
                        React.createElement("div", { className: "c-accordian__dropdown" },
                            React.createElement("span", { className: "c-accordian__icon" }),
                            React.createElement("span", { className: "c-accordian__text" }, title))),
                    React.createElement("div", { className: bodyClass },
                        React.createElement("div", { className: "c-accordian__title" },
                            React.createElement("span", { className: "c-accordian__icon" }),
                            React.createElement("span", { className: "c-accordian__text" }, props.menu.name)),
                        props.menu.children.map(function (it, i) { return renderMenuItem(it, i, props); })))),
            React.createElement("div", { className: "l-container__main" }, props.children)),
        React.createElement(Enquire_1.default, null),
        React.createElement(Megafoot_1.default, null),
        React.createElement(Login_1.default, null),
        React.createElement(ServerSideSchema_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(mortgagePage);
